export default [
  {
    path: '/rent/v2/commonRenter',
    name: 'commonRenter',
    component: () => import('@/pages/commonRenter/index'),
    meta: { title: '订单', requireAuth: true },
    children: [
      {
        path: 'list',
        name: 'commonRenterList',
        component: () => import('@/pages/commonRenter/list'),
        meta: { title: '常用租车人', requireAuth: true },
      },
      {
        path: 'new',
        name: 'commonRenterNew',
        component: () => import('@/pages/commonRenter/new'),
        meta: { title: '添加租车人', requireAuth: true },
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/pages/commonRenter/commonRenter.js